<template>
	<el-row>
		<el-table :data="tableData" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" row-key="id"
			border>
			<el-table-column prop="id" label="编号" width="180" align="center" />
			<el-table-column prop="name" label="分类名称" align="center" />
			<el-table-column prop="level" label="分类等级" align="center" />
			<el-table-column prop="showStatus" label="是否在商城显示" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.showStatus" active-color="#13ce66" inactive-color="#ff4949"
						active-value="1" inactive-value="0" disabled />
				</template>
			</el-table-column>
			<el-table-column prop="showStatus" label="是否同步" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.paiStatus" active-color="#13ce66" inactive-color="#ff4949"
						:active-value="1" :inactive-value="0" @change="displayButton(scope.$index, scope.row)" />
				</template>
			</el-table-column>
			<el-table-column prop="description" label="分类描述" align="center" />
		</el-table>
		<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
			:page-size="pageSize" :page-sizes="[30, 50, 100]" :total="total" :current-page.sync="pageNum"
			@size-change="handleSizeChange" @current-change="handleCurrentChange" />
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				total: 0,
				pageSize: 30,
				pageNum: 1,
			};
		},
		methods: {
			getInfo() {
				this.$http.get(
						"/api/product/productCategory/paiCategory?pageSize=" +
						this.pageSize +
						"&pageNum=" +
						this.pageNum, {}
					)
					.then((res) => {
						console.log(res);
						this.tableData = res.data.data.list;
						this.total = res.data.data.total;
					});
			},
			displayButton(index, row) {
				console.log(row);
				let paiStatus = ''
				if (row.paiStatus == 0) {
					paiStatus = 0
				} else {
					paiStatus = 1
				}
				this.$http.get("/api/product/productCategory/isToPai?id=" + row.id + "&paiStatus=" + paiStatus, {}).then((
					res) => {
					console.log(res.data.status);
					if (res.data.status == 0) {
						this.$message.success('同步成功')
					} else {
						this.$message.error('同步失败');
					}
					this.getInfo()
				})
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getInfo();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getInfo();
			},
		},
		created() {
			this.getInfo();
		},
	};
</script>

<style lang="scss" scoped>
	.pagination {
		margin-left: 50%;
		margin-top: 20px;
		z-index: 2;
		transform: translateX(-50%);
	}
</style>>
